<!--
 * @Descripttion: 房产公文列表
 * @Author: jschen
 * @Date: 2021-08-29 17:26:02
 * @LastEditors: chenjinsheng
 * @LastEditTime: 2021-11-25 14:44:01
-->
<template>
    <div class="house-system-container">
        <div class="system-box house-table-box">
            <!-- <header class="top-header">
                <div class="breadcrumb">
                    <el-breadcrumb separator="/">
                        <el-breadcrumb-item :to="{ path: '/work-portal/index' }">
                            <i class="icon-home"></i> 首页
                        </el-breadcrumb-item>
                        <el-breadcrumb-item>房产公文</el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
            </header> -->
            <div class="content-box">
                <!-- <el-scrollbar class="left-box overflow-x-hidden">
                    <el-tree
                        ref="newsTree"
                        :data="dataTree"
                        :props="defaultProps"
                        default-expand-all
                        :highlight-current="true"
                        :expand-on-click-node="false"
                        :current-node-key="currentNodeKey"
                        node-key="id"
                        @node-click="handleNodeClick"
                    ></el-tree>
                </el-scrollbar> -->
                <div class="right-box">
                    <div class="sort-box">
                        <div class="sort-title"><span>房产公文列表</span></div>
                        <div class="search-right-box">
                            <el-input v-model="keyword" size="mini" placeholder="标题关键字搜索" style="width:180px;">
                                <i
                                    v-if="!isNeedShowClose"
                                    slot="prefix"
                                    class="el-input__icon el-icon-search"
                                    @click.stop="searchKw"
                                ></i>
                                <i v-else slot="suffix" class="el-input__icon el-icon-close" @click.stop="clearKw"></i>
                            </el-input>
                            <div class="sort-right-box">
                                <el-button plain size="mini" @click="refresh">刷新</el-button>
                            </div>
                        </div>
                    </div>
                    <el-table
                        v-loading="loading"
                        :data="noticeData.records"
                        style="width: 100%;"
                        height="calc(100% - 60px)"
                    >
                        <el-table-column label="序号" width="55" align="center">
                            <template slot-scope="scope">{{ scope.$index + 1 }}</template>
                        </el-table-column>
                        <el-table-column label="标题">
                            <template slot-scope="scope">
                                <span v-if="scope.row.isShowNew" class="newIcon">新</span>
                                <a :href="scope.row.link" target="_blank" style="cursor:pointer;">{{
                                    scope.row.subject
                                }}</a>
                            </template>
                        </el-table-column>
                        <el-table-column prop="number" label="文件编号" width="120"></el-table-column>
                        <el-table-column prop="drafter" label="拟稿人" width="120"></el-table-column>
                        <el-table-column prop="unit" label="发文单位" width="180"></el-table-column>
                        <el-table-column prop="publishtime" width="180">
                            <template slot="header" slot-scope="scope">
                                <div @click="sortChange('publishTime')">
                                    发布日期
                                    <span class="caret-wrapper" @click="sortChange('publishTime', 'up', scope.row)">
                                        <i
                                            class="sort-caret ascending"
                                            :class="{
                                                active:
                                                    searchOpt.orderByType == 'publishTime' && searchOpt.orderBy == 'up',
                                            }"
                                            @click.stop="sortChange('publishTime', 'up')"
                                        ></i>
                                        <i
                                            class="sort-caret descending"
                                            :class="{
                                                active:
                                                    searchOpt.orderByType == 'publishTime' &&
                                                    searchOpt.orderBy == 'down',
                                            }"
                                            @click.stop="sortChange('publishTime', 'down')"
                                        ></i>
                                    </span>
                                </div>
                            </template>
                            <template slot-scope="scope">
                                <span>{{ scope.row.publishtime }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="公文状态" width="80">
                            <template slot-scope="scope">
                                <div>
                                    {{
                                        scope.row.status == 20
                                            ? "待审"
                                            : scope.row.status == 11
                                            ? "驳回"
                                            : scope.row.status == 30
                                            ? "结束"
                                            : scope.row.status == 31
                                            ? "已反馈"
                                            : "废弃"
                                    }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="nodevalue" label="当前环节" width="100"></el-table-column>
                    </el-table>
                    <div class="pagination-box">
                        <el-pagination
                            :current-page="searchOpt.current"
                            :page-sizes="[15]"
                            :page-size="15"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="noticeData.total"
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                        ></el-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import sortMixin from "@/mixins/sort-mixins";
import { debounce } from "@/libs/mUtils";
export default {
    name: "SystemManage",
    components: {},
    mixins: [sortMixin],
    data() {
        return {
            activeId: 0,
            noticeData: {
                records: [],
            },
            resourceOpt: [],
            activeTypeId: "",
            houseNoticeType: [],
            isNeedShowClose: false, //是否需要展示关闭 x x
            sortOptionArr: [
                {
                    name: "拟稿日期",
                    filed: "createTime",
                    status: "", //默认为空，降序：down，升序：up，首次点击显示降序
                },
                {
                    name: "发布日期",
                    filed: "publishTime",
                    status: "",
                },
            ],
            loading: false,
            keyword: "",
            searchOpt: {
                title: "",
                orderByType: "publishTime", //最新 new；发布时间:publishTime；点击率:readCount
                orderBy: "down", //排序方式，升序：up；降序：down
                fdMainDept: "",
                current: 1,
                size: 15,
            },
            dataTree: [],
            defaultProps: {
                children: "children",
                label: "label",
            },
            currentNodeKey: "",
        };
    },
    watch: {
        keyword(newVal) {
            if (newVal) {
                this.isNeedShowClose = true;
            } else {
                this.isNeedShowClose = false;
            }
            this.debounce();
        },
    },
    async created() {
        // await this.$axios.get("/work/common/oa/officialType").then((res) => {
        //     res.body.unshift({
        //         orgId: "",
        //         orgIds: "",
        //         orgName: "全部",
        //         orgParentId: "",
        //         children: [],
        //     });
        //     this.dataTree = this.deepMapArr(res.body);
        // });
        this.getList(this.searchOpt.fdMainDept);
        this.debounce = debounce(this.searchKw, 500);
    },
    methods: {
        /**
         * 递归遍历
         */
        deepMapArr(arr) {
            if (arr && arr.length > 0) {
                let data = [];
                arr.forEach((el) => {
                    if (el.orgName === "全部") {
                        this.currentNodeKey = this.searchOpt.fdMainDept = el.orgIds;
                        this.$nextTick(() => {
                            this.$refs.newsTree.setCurrentKey(this.currentNodeKey);
                        });
                    }
                    if (el.children.length > 0) {
                        let item = this.deepMapArr(el.children);
                        el.children = [...item];
                    }
                    data.push({
                        id: el.orgIds,
                        label: el.orgName,
                        children: el.children,
                    });
                });
                return data;
            }
        },
        /**
         * 点击节点回调
         */
        handleNodeClick(data) {
            this.searchOpt.fdMainDept = data.id;
            this.searchOpt.title = this.keyword;
            this.getList(this.searchOpt.fdMainDept);
        },
        /**
         * 获取列表
         */
        getList() {
            this.loading = true;
            this.$axios.post("/work/common/oa/official", this.searchOpt).then((res) => {
                this.noticeData = res.body;
                this.noticeData.records.forEach((el) => {
                    let timeDis = +new Date() - +new Date(el.publishtime);
                    if (timeDis / (3600 * 1000 * 24) < 3) {
                        this.$set(el, "isShowNew", true);
                    } else {
                        this.$set(el, "isShowNew", false);
                    }
                });
                this.loading = false;
            });
        },
        /**
         * 搜索关键字
         */
        searchKw() {
            if (this.searchOpt.title !== this.keyword) {
                if (this.keyword !== "") {
                    this.isNeedShowClose = true;
                }
                this.searchOpt.title = this.keyword;
                this.getList();
            }
        },
        /**
         * 清空关键字
         */
        clearKw() {
            this.searchOpt.title = this.keyword = "";
            this.getList();
            this.isNeedShowClose = false;
        },
        /**
         * 刷新
         */
        refresh() {
            this.searchOpt = {
                title: "",
                orderByType: "publishTime", //最新 new；发布时间:publishTime
                orderBy: "down", //排序方式，升序：up；降序：down
                fdMainDept: "",
                current: 1,
                size: 15,
            };
            this.keyword = "";
            this.sortOptionArr.forEach((el) => {
                el.status = "";
            });
            this.currentNodeKey = "";
            this.$nextTick(() => {
                this.$refs.newsTree.setCurrentKey(this.currentNodeKey);
            });
            this.getList();
        },
        /**
         * 选择房产公文类型
         */
        chooseNoticeType(id) {
            this.searchOpt.orgId = id;
            this.getList();
        },
        handleSizeChange(val) {
            this.searchOpt.current = 1;
            this.searchOpt.size = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.searchOpt.current = val;
            this.getList();
        },
    },
};
</script>
<style lang="scss">
.house-system-container {
    height: calc(100vh - 48px);
    margin: 0 7%;
    .top-header {
        display: flex;
        align-items: center;
        height: 80px;
        line-height: 80px;
        .breadcrumb {
            width: 100%;
            height: 40px;
            padding: 0 20px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            background: #ffffff;
            border-radius: 4px;
            .el-breadcrumb__item,
            .el-breadcrumb__inner {
                display: flex;
                align-items: center;
                height: 40px;
            }
            .icon-home {
                display: inline-block;
                width: 16px;
                height: 16px;
                background: url("~assets/pics/home-icon.png");
                background-size: 100% 100%;
                margin-right: 12px;
            }
        }
    }
}
</style>
<style lang="scss" scoped>
@import "./style.scss";
.house-table-box {
    .el-table th {
        padding: 0 !important;
        font-weight: normal;
        background: #f9f9f9;
    }
    .el-table td {
        padding: 5px 0 !important;
    }
    .el-table th div {
        height: 32px;
        line-height: 32px;
    }
}
.system-box {
    width: 100%;
    height: 100%;
    .el-breadcrumb__inner.is-link {
        font-weight: 400;
        color: #000;

        &:hover {
            color: $primary;
        }
    }
    .el-tree-node__content {
        height: 32px;
        border-bottom: 1px solid #f5f5f5;
    }
    .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
        background: $primary;
        color: #fff;
    }
    .el-breadcrumb__inner.is-link {
        font-weight: 400;
        color: #000;

        &:hover {
            color: $primary;
        }
    }
    .el-tree-node__content:hover {
        color: $primary;
        background: #f0f7f5;
    }
}
.flex-between {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.sort-caret {
    &:nth-child(1) {
        &.active {
            border-bottom-color: $primary;
        }
    }
    &:nth-child(2) {
        &.active {
            border-top-color: $primary;
        }
    }
}
.content-box {
    width: 100%;
    height: 100%;
    // height: calc(100% - 82px);
    display: flex;
    /deep/ table thead {
        tr th {
            background: #f9f9f9;
        }
    }
    .left-box {
        width: 200px;
        height: 100%;
        flex-shrink: 0;
        color: #333333;
        background: #fff;
        /deep/ .el-tree {
            width: 176px;
            margin-left: 12px;
        }
        /deep/ .el-tree-node__content {
            margin: 5px 0;
            height: 40px;
            line-height: 40px;
        }
        /deep/ .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
            color: #ffffff;
            background: #47a489;
            border-radius: 8px;
        }
    }
    .right-box {
        width: 100%;
        // margin-left: 20px;
        .newIcon {
            display: inline-block;
            width: 18px;
            height: 18px;
            line-height: 18px;
            text-align: center;
            color: #e7505a;
            background: #fadcde;
            margin-right: 5px;
        }
    }
    .sort-box {
        width: 100%;
        height: 40px;
        @extend .flex-between;
        padding: 0 20px;
        border-bottom: 1px solid #cdcfd4;
        background: #fff;

        .sort-title {
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: bold;
            color: #000000;
            &::before {
                position: relative;
                top: 2px;
                left: -5px;
                display: inline-block;
                content: "";
                width: 2px;
                height: 16px;
                margin-right: 5px;
                background: #47a489;
            }
        }

        .search-right-box {
            display: flex;
            justify-content: flex-start;

            .sort-right-box {
                margin-left: 12px;
                @extend .flex-between;

                .time {
                    display: flex;
                    align-items: center;
                }
            }
        }
    }
    .pagination-box {
        display: flex;
        height: 60px;
        align-items: center;
        justify-content: flex-end;
        padding-right: 20px;
        background: #fff;
    }
}
</style>
